import { Field, ErrorMessage, FieldInputProps } from "formik";
import { useTranslation } from "react-i18next";
import { TitleInput } from "@/screens/register/register-engineer/style";
import PasswordInputWithToggle from "@/components/password-input-with-toggle/password-input-with-toggle";
import { ErrorText, MarginBottom } from "@/screens/login/login-seller/style";

interface Props {
  registerError: any;
}

export default function StepEngineerAccess({ registerError }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <TitleInput>{t("password")}</TitleInput>
      <Field name="password">
        {({ field }: { field: FieldInputProps<any> }) => (
          <PasswordInputWithToggle
            field={field}
            placeholder={t("type-password")}
          />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="password" />
      </ErrorText>

      <MarginBottom />

      <TitleInput>{t("confirm-password")}</TitleInput>
      <Field name="confirm_password">
        {({ field }: { field: FieldInputProps<any> }) => (
          <PasswordInputWithToggle
            field={field}
            placeholder={t("type-password")}
          />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="confirm_password" />
      </ErrorText>
    </>
  );
}
